import React, { useEffect } from "react";
import PageNavigation from "./PageNavigation.jsx";
import PageFooter from "./PageFooter.jsx";
import Container from "./Container.jsx";
import PageTitle from "./PageTitle.jsx";
import { useLocation } from "react-router-dom";

const topNavigation = [
  { title: "Home", path: "/", colour: "border-proof-green" },
  { title: "About", path: "/about", colour: "border-proof-orange" },
  { title: "Contact", path: "/contact", colour: "border-proof-blue" },
  { title: "Research", path: "/research", colour: "border-proof-yellow" },
  { title: "Resources", path: "/resources", colour: "border-proof-purple" },
];

const PageLayout = ({ children, title, className, isFullWidth }) => {
  const location = useLocation();

  // updates header canonical link seo
  useEffect(() => {
    let canonicalTag = document.querySelector("link[rel='canonical']");
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.rel = "canonical";
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.href = `https://proof-online.net${location.pathname}`;
  }, [location]);

  return (
    <div className="flex h-full flex-col">
      <PageTitle title={title || ""} />
      <PageNavigation links={topNavigation} useColours={true} />
      <main className={className}>
        {isFullWidth ? children : <Container>{children}</Container>}
        <div className="h-10"></div>
      </main>
      <PageFooter />
    </div>
  );
};
export default PageLayout;
